// 1 inch is exactly 25.4 millimetres (international inch).
export const MM_PER_INCH = 25.4

// Rounds to a fixed number of decimals and returns a real number (not a string),
// so callers can keep doing maths with the result.
const round = (value: number, digits: number): number => Number(value.toFixed(digits))

// Accepts numbers or numeric strings (form inputs / API values come as strings sometimes).
// Returns NaN when the value cannot be read as a number, so callers can check with
// Number.isNaN() instead of silently getting 0.
const toNumber = (value: number | string): number => {
  if (typeof value === 'number') {
    return value
  }

  if (typeof value !== 'string' || value.trim() === '') {
    return NaN
  }

  // Support comma decimals ("12,5") used by the EU locales.
  return Number(value.trim().replace(',', '.'))
}

// Inches -> millimetres. Default 2 decimals is enough for label dimensions.
export const inchesToMm = (value: number | string, digits = 2): number => {
  const inches = toNumber(value)
  return Number.isNaN(inches) ? NaN : round(inches * MM_PER_INCH, digits)
}

// Millimetres -> inches. Default 3 decimals, because 1 mm is only ~0.039 in
// and 2 decimals would lose too much precision.
export const mmToInches = (value: number | string, digits = 3): number => {
  const mm = toNumber(value)
  return Number.isNaN(mm) ? NaN : round(mm / MM_PER_INCH, digits)
}
